import { useUserProfile } from "@pontimed/auth-client";

import { useBrowsingCountry } from "./use-browsing-country";

/**
 * D2 (launch-readiness): canonical country for registration/claim flows —
 * the hardcoded `country="RO"` in the add wizards gave BG self-registering
 * doctors RO specialties + RO geocoding bias.
 *
 * Resolution order:
 *   1. authenticated user's residence (`User.primaryCountry`, set at signup)
 *   2. browsing-country cookie (`.pontimed.app`, set by marketing/find flows)
 *   3. "RO" (platform default)
 *
 * Returns uppercase ISO-2. `isLoading` is true only while the profile query
 * is still in flight AND no cookie fallback is available.
 */
export function useDefaultCountry(): { country: string; isLoading: boolean } {
  const { data: profile, isLoading: profileLoading } = useUserProfile();
  const { country: cookieCountry, isHydrated } = useBrowsingCountry();

  const fromProfile = profile?.primaryCountry?.toUpperCase();
  const fromCookie = cookieCountry?.toUpperCase();

  return {
    country: fromProfile || fromCookie || "RO",
    isLoading: profileLoading && !isHydrated,
  };
}
